import { DateTimePickerProps, DateTimePickerState, DateTimePickerHandler } from "./datetimepicker";
import { DateTimePickerCSSStyleImpl } from "./datetimepickercss";
import * as React from "react";
import { DateTimePickerItem } from "./datetimepickeritem";
import { UIDataModel, UIComponentHandler } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';

export class DateTimePickerView extends UIComponentViewImpl<UIDataModel>
{
    
    constructor(prop:any, handler:UIComponentHandler)
    {
        super(prop, handler);

    }
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
    }
    
    draw(uiProps: DateTimePickerProps, uiState: DateTimePickerState, cssStyle: DateTimePickerCSSStyleImpl): JSX.Element 
    {
       super.draw(uiProps, uiState, cssStyle);

       return(
        <DateTimePickerItem value={uiState.value} contentType={uiProps.inputType!==undefined ? uiProps.inputType:"text"} hint={""}  onChange={this.onChange} label={""} isRequired={uiProps.isRequired} style={cssStyle} disabled={uiProps.isDisabled===undefined?false:uiProps.isDisabled} errorMessage={uiState.errorMessage} autocomplete={uiProps.autocomplete!==undefined ? uiProps.autocomplete:"off"} onKeyPress={uiProps.onKeyPress}/>
       );
    }
    onChange(e : any): void {
        (this.getUIComponentHandler() as DateTimePickerHandler).onChange(e);
    }
    
    validate(): boolean
    {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/datetimepicker/datetimepickerview.tsx